import { render, staticRenderFns } from "./SsoLogin.vue?vue&type=template&id=26a2d32c&scoped=true&"
import script from "./SsoLogin.vue?vue&type=script&lang=js&"
export * from "./SsoLogin.vue?vue&type=script&lang=js&"
import style0 from "./SsoLogin.vue?vue&type=style&index=0&id=26a2d32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a2d32c",
  null
  
)

export default component.exports